import { FETCH_BANNERS } from "../actions/types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_BANNERS:
      return action.payload;

    default:
      return state;
  }
};
